import * as R from 'ramda';
import React from 'react';
import classNames from 'classnames';

import {prettyNumber} from 'js/common/string_helper';
import {ENUMS} from 'js/common';

// Components
import RatingSection from './rating_section';

export default class StoryGridItem extends React.Component {
    handleClickScore = (e, score) => {
        e.preventDefault();
        e.stopPropagation();

        const {setPostScore, setSelectedPostAndComment, post} = this.props;
        setPostScore(score, post.post_id);
        setSelectedPostAndComment(post.content_metadata_id);
    };

    displayPlayButtonOverlay = () => {
        const {content_type} = this.props.post;

        if (content_type === ENUMS.ContentType.VIDEO) {
            return <div className="play-button-overlay" />;
        }

        return null;
    };

    displayImpressionsSection = () => {
        const {compositionMetrics} = this.props;

        const sumImpressions = R.pipe(
            R.defaultTo([]),
            R.map(R.path(['_source', 'impressions'])),
            R.sum
        )(compositionMetrics.metrics);

        return (
            <div className="engagement-rate">
                <div>{sumImpressions > 999 ? prettyNumber(sumImpressions) : sumImpressions}</div>
                <div>Impressions</div>
            </div>
        );
    };

    displayReachRepliesSection = () => {
        const {compositionMetrics} = this.props;

        const reach = R.pipe(R.defaultTo([]), R.map(R.pathOr(0, ['_source', 'reach'])), (reaches) =>
            reaches.length ? Math.max(...reaches) : 0
        )(compositionMetrics.metrics);

        const replies = R.pipe(
            R.defaultTo([]),
            R.map(R.pathOr(0, ['_source', 'replies'])),
            R.defaultTo([]),
            R.sum
        )(compositionMetrics.metrics);

        return (
            <div className="post-metric likes-comments">
                <div className="post-likes">
                    <i className="fa fa-bullhorn" />
                    {reach > 999 ? prettyNumber(reach) : reach}
                </div>
                <div className="post-comments">
                    <i className="fa fa-comment-o" />
                    {replies > 999 ? prettyNumber(replies) : replies}
                </div>
            </div>
        );
    };

    displayRatingsSection = () => {
        const {showPostScore, showAvgScore} = this.props;
        const {post_user_score, avg_post_user_score} = this.props.post;
        const avgScoreShown = showAvgScore ? avg_post_user_score : null;

        if (showPostScore) {
            return (
                <RatingSection
                    handleClickScore={this.handleClickScore}
                    postUserScore={post_user_score}
                    avgUserScore={avgScoreShown}
                />
            );
        }
    };

    render() {
        const {currentCardSize, setSelectedPost} = this.props;

        const {content_metadata_id, content_type, thumbnail_url} = this.props.post;

        const playButtonOverlay = this.displayPlayButtonOverlay();
        const ratingSection = this.displayRatingsSection();

        const postGridItemClasses = classNames('post', currentCardSize, content_type);
        const postStyle = {
            backgroundImage: `url(${thumbnail_url})`
        };

        return (
            <div
                className={postGridItemClasses}
                style={postStyle}
                onClick={() => {
                    setSelectedPost(content_metadata_id);
                }}
            >
                {playButtonOverlay}
                <div className="post-overlay">
                    {this.displayReachRepliesSection()}
                    {this.displayImpressionsSection()}
                    {ratingSection}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/post_grid_item/story_grid_item.js